import React from "react";
import Right from "@material-ui/icons/NavigateNext";
import Left from "@material-ui/icons/NavigateBefore";
import Close from "@material-ui/icons/Close";

export const Gallery = ({ arr }) => {
  const [modal, setModal] = React.useState(false);
  const [selected, setSelected] = React.useState(0);
  const [pDivs, setPDivs] = React.useState([]);

  const imgs = arr;
  const videoWidth = 95;

  React.useEffect(() => {
    setPDivs(
      imgs.map((e, i) => {
        return (
          <div
            key={i}
            className="gallery-item"
            style={{ backgroundImage: `url(${e})`, backgroundSize: "cover" }}
            onClick={() => {
              setSelected(i);
              setModal(true);
            }}
          ></div>
        );
      })
    );
  }, []);

  return (
    <div id="gallery" className="flex row wrap">
      <div
        className="modal flex"
        style={{ display: modal ? "flex" : "none", cursor: "zoom-out" }}
        onClick={() => setModal(false)}
      >
        <div
          key={imgs[selected]}
          className="flex start"
          style={{
            width: `${videoWidth}vw`,
            height: `${videoWidth * 0.5625}vw`,
            cursor: "initial",
            maxWidth: "1500px",
            maxHeight: "843.75px",
          }}
        >
          <div
            className="img-nav flex row"
            style={{
              zIndex: 10,
              width: "100%",
              maxWidth: "1500px",
              justifyContent: "space-between",
              position: "absolute",
              top: "50%",
            }}
          >
            <div
              className="btn viewer"
              style={{ margin: "16px", fontSize: "1rem" }}
              onClick={(e) => {
                e.stopPropagation();
                setSelected(selected === 0 ? imgs.length - 1 : selected - 1);
              }}
            >
              <Left style={{ color: "white", fontSize: "2rem" }} />
            </div>

            <div
              className="btn viewer"
              style={{ margin: "16px", fontSize: "1rem" }}
              onClick={(e) => {
                e.stopPropagation();
                setSelected(selected === imgs.length - 1 ? 0 : selected + 1);
              }}
            >
              <Right style={{ color: "white", fontSize: "2rem" }} />
            </div>
          </div>

          <div
            className="video flex"
            onClick={(e) => {
              e.stopPropagation();
              setSelected(selected === imgs.length - 1 ? 0 : selected + 1);
            }}
            style={{
              cursor: "pointer",
              backgroundImage: `url(${imgs[selected]})`,
              width: "100%",
              height: "100%",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
        </div>
        <div
          className="btn viewer"
          style={{
            margin: "16px",
            fontSize: "1rem",
            position: "absolute",
            top: 0,
            right: 0,
          }}
          onClick={() => setModal(false)}
        >
          <Close style={{ color: "white", fontSize: "2rem" }} />
        </div>
        <div
          style={{
            color: "white",
            fontSize: "1rem",
            width: "70px",
            textAlign: "end",
            position: "absolute",
            bottom: "32px",
          }}
        >
          {selected + 1} of {imgs.length}
        </div>
      </div>
      {pDivs}
    </div>
  );
};
